export const transactionTypesSettlementURL = {
  SALESTRANS_SUMMARY: 'sales-transaction-summaries',
  SALES_PAYMENT: 'sales-payments',
  SALES_CREDIT: 'sales-credits',
  SALES_DIFF: 'sales-differences',
  SALES_DEPOSIT: 'sales-deposits',
  SALES_MANUALLINE: 'sales-manual-lines',
  GENERIC_TRANSACTION: 'generic-transactions',
};

export const transactionTypesIncomingSettlementURL = {
  SALESTRANS_SUMMARY: 'sales-transaction-summary-imports',
  SALES_PAYMENT: 'sales-payment-imports',
  SALES_CREDIT: 'sales-credit-imports',
  SALES_DIFF: 'sales-difference-imports',
  SALES_DEPOSIT: 'sales-deposit-imports',
  SALES_MANUALLINE: 'sales-manual-line-imports',
  GENERIC_TRANSACTION: 'generic-transaction-imports',
};
